import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Auth from '@aws-amplify/auth';
// app
import { addAuth, deleteAuth, addSession, updateSession, openSnackbar, closeSnackbar } from '../../store/action-creators';
import { colors } from '../../config/styles';
// containers
import AppContainer from '../../containers/App';
// models
import { Session, Auth as AuthEntity } from '../../entities/auth';
import { Message, MessageTypes } from '../../entities/site';
// components
import ActionButton from '../../components/buttons/ActionButton';
import RowContainer from '../../containers/Row';
import TextInput from '../../components/inputs/TextInput';
// services
import UtilsService from '../../services/utils';
import AuthService from '../../services/auth';

const styles: any = {
  container: {
    height: "100%",
    minHeight: "100%",
    maxWidth: 600,
    margin: '0px auto',
    padding: 40,
    backgroundColor: '#FFF'
  },
  link: {
    color: colors.blue,
    cursor: 'pointer'
  },
  footer: {
    fontSize: 12,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  divider: {
    width: 1,
    backgroundColor: '#999',
    height: 15,
    marginLeft: 10,
    marginRight: 10
  }
}

interface ConfitmPageProps {
  history: any;
  session: Session;
  addAuth(auth: AuthEntity): void;
  deleteAuth(): void;
  addSession(session: Session): void;
  updateSession(session: Session): void;
  openSnackbar(msg: string): void;
  closeSnackbar(): void;
}

interface ConfirmPageState {
  loading: boolean;
  disabled: boolean;
  email: string;
  code: string;
  step: number;
}

class ConfirmPage extends Component<ConfitmPageProps, ConfirmPageState> {

  constructor(props: ConfitmPageProps) {
    super(props);
    this.state = {
      loading: false,
      disabled: false,
      email: '',
      code: '',
      step: 0
    }
  }

  componentDidMount = () => {
    // home
  }

  handleEmailConfirm = async () => {
    console.log('clicked')



    try {
       // let redirectUrl = '/';
      this.setState({ loading: true, disabled: true });

      Auth.resendSignUp(this.state.email).then(() => {
        this.props.openSnackbar('Confirm code has been sent to email');
        this.setState({ step: 1 });

      }).catch(e => {
        this.props.openSnackbar('Error sending code');
      });

      this.setState({ loading: false, disabled: false });
      // this.handleRoute('/');

    } catch (error) {
      console.log('error', error);
      this.setState({ loading: false, disabled: false });
      // this.props.setMessage({message: 'Error logging in', messageType: MessageTypes.error});
      await UtilsService.logError(AuthService.getApiUrls().core, 'Login', 'handleLogin', error);
    }

  }

  handleRoute = (route: string) => {
    this.props.history.push(route);
  }

  onEmailChange = (event: any) => {
    this.setState({ email: event.target.value });
  }

  onCodeChange = (event: any) => {
    this.setState({ code: event.target.value });
  }


  render() {
    return (
      <AppContainer showOption={false} private={false} maxWidth="lg">
        <div style={styles.container}>
          {this.state.step === 0 &&
            <RowContainer>
              <TextInput
                type="string"
                placeholder="Email"
                title="Email"
                result={this.state.email}
                onChange={this.onEmailChange}
              />
            </RowContainer>
          }
          {this.state.step === 1 &&
            <RowContainer>
              <TextInput
                type="string"
                placeholder="Code"
                title="Code"
                result={this.state.code}
                onChange={this.onCodeChange}
              />
            </RowContainer>
          }
          <RowContainer>
            <ActionButton name="Submit" onClick={this.handleEmailConfirm} loading={this.state.loading} size="sm" fullWidth disabled={this.state.disabled} />
          </RowContainer>
        </div>
      </AppContainer>
    )
  }

}

const mapStateToProps = (state: any) => {
  return {
    session: state.session.session
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ addAuth, deleteAuth, addSession, updateSession, openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(ConfirmPage));



// WEBPACK FOOTER //
// ./src/pages/auth/Confirm.tsx